/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import { Icon, Button, Header, Form, Modal, Label, Image } from 'semantic-ui-react'

import NameField from '../../fields/nameField'
import CodeField from '../../fields/codeField'
import PublishField from '../../fields/publishField'
import DescriptionField from '../../fields/descriptionField'
import PriceField from '../../fields/priceField'

export default class ItemSearchForm extends React.PureComponent {
  state = {
    label: '',
  }

  btnSubmitRef = React.createRef()

  componentDidMount() {
    const { action, itemData } = this.props

    if (action === 'edit') {
      this.setState({ label: `Edit ${itemData.name}` })
    }
  }

  getTags = () => {
    const { storeData, tags } = this.props

    const options = _.map(storeData.tags || {}, (tag, tagKey) => ({
      key: tagKey,
      value: tagKey,
      text: tags[tagKey],
    }))

    if (_.size(options) > 0) {
      options.push({ key: 'unselect', value: '@unselect', text: 'Unselect' })
    }

    return options
  }

  onTagChange = (e, { value }) => {
    const { onFieldChange } = this.props

    if (value === '@unselect') {
      value = ''
    }

    onFieldChange('tag', value)
  }

  onSave = () => {
    const { saveItem } = this.props

    return saveItem()
  }

  render() {
    const { label } = this.state
    const {
      action,
      loading,
      onClose,
      visible,
      itemData,
      itemOptions,
      onFieldChange,
      onOptionOrderChange,
      onRemoveOption,
      arrangeOptions,
      onUpload,
      showImage,
    } = this.props

    const { images, name, code, tag, status, current_price: currentPrice, description, skip_automate_update: skipAutomateUpdate} = itemData

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'new' ? 'Add New Item' : label} />
        <Modal.Content style={{ maxHeight: 600, overflow: 'auto' }} className="branch-form">
          <Form
            // onSubmit={this.onSave}
            // ref={ref => {
            //   this.btnSubmitRef = ref
            // }}
            disabled={loading}
          >
            {showImage &&
              (images && images.thumb ? (
                <div>
                  <Image
                    src={images.thumb}
                    size="small"
                    rounded
                    centered
                    style={{ width: 100, height: 100 }}
                    onClick={onUpload}
                    // onLoad={() => this.setState({ imageLoaded: true })}
                  />
                </div>
              ) : (
                <div
                  style={{
                    height: '100px',
                    alignItems: 'inherit',
                    display: 'flex',
                    justifyContent: ' center',
                  }}
                >
                  <Button onClick={onUpload}>Upload</Button>
                </div>
              ))}
            <Form.Group widths="equal">
              <NameField onChange={onFieldChange} value={name} />
            </Form.Group>
            <Form.Group widths="equal">
              <CodeField onChange={onFieldChange} value={code} />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Dropdown
                label="Tag"
                placeholder="Select Item Tag"
                fluid
                search
                selection
                value={tag}
                options={this.getTags()}
                onChange={this.onTagChange}
              />
              <PublishField value={status} onChange={onFieldChange} />
            </Form.Group>
            <Form.Group widths="equal">
              <PriceField value={currentPrice} onChange={onFieldChange} />
            </Form.Group>
            <Form.Group widths="equal">
              <DescriptionField value={description} onChange={onFieldChange} />
            </Form.Group>
            <Form.Group>
                <Form.Checkbox
                  label='Skip Automation'
                  checked={skipAutomateUpdate}
                  onChange={(e, { checked }) =>  onFieldChange('skip_automate_update', checked) }
                />
              </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
            {arrangeOptions.length > 0 && (
              <Form.Field>
                <label>Options</label>
                <div>
                  {arrangeOptions.map((optionKey, index) => {
                    const itemOptionKey = itemOptions[optionKey]
                    if (!itemOptionKey) return null
                    return (
                      <div
                        key={itemOptionKey.name}
                        style={{ display: 'flex', marginRight: 5, marginBottom: 5 }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <Icon name="angle up" onClick={() => onOptionOrderChange(index, 'up')} />
                          <Icon name="angle down" onClick={() => onOptionOrderChange(index, 'down')} />
                        </div>
                        <Label size="medium" as="a" onClick={() => onRemoveOption(optionKey)} color="blue">
                          {itemOptionKey.name}
                          <Icon name="delete" />
                        </Label>
                      </div>
                    )
                  })}
                </div>
              </Form.Field>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() =>  this.onSave()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemSearch/form.js